import {JournalModalWindow} from './JournalModalWindow';
export default JournalModalWindow;
